module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_8.a8d445f2.png";